module.exports = __FOREMAN_VENDOR__ACE_BUILDS_SRC_NOCONFLICT_EXT_LANGUAGE_TOOLS__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__ACE_BUILDS_SRC_NOCONFLICT_EXT_LANGUAGE_TOOLS__"
// module id = ace-builds/src-noconflict/ext-language_tools
// module chunks = 0 1 2